export default __webpack_public_path__ + "static/media/dark-pencil.df338a27.svg";